import { validateComponent } from '../../../../utils'

const checkboxValidator = (component) => {
  const { options } = component

  const validators = [
    {
      validationFunction: () => options.value.trim().length > 0,
      validationKey: 'value',
      validationMessage: 'Please enter your question!',
    },
    {
      validationFunction: () =>
        options.optionItems.some((item) => item.trim().length > 0),
      validationKey: 'optionItems',
      validationMessage: 'Please add at least one option!',
    },
  ]

  validateComponent(component, validators)

  return component.isValid
}

export default checkboxValidator
